import React from "react";
import Layout from 'layout/index.js'

import { Link } from 'react-router-dom';


import { authenticationService } from 'auth/authenticationService'
import {
          Paper,
          Box,
          Button,
          Typography,
          Alert,
          TextField,
          TableSortLabel,TablePagination,TableContainer,Table,TableRow,TableHead,TableBody,TableCell,
          CircularProgress,
          Dialog, DialogContent, DialogActions,
          // FormHelperText,

        } from '@mui/material';
  
const headCells = [
  { id: "created_at", numeric: false, disablePadding: false, label: "Fecha creación", sorting: true},
  { id: "rol", numeric: false,disablePadding: false,label: "Rol", sorting: true},
  { id: "nombre", numeric: false,disablePadding: false,label: "Nombre", sorting: true},
  { id: "numero", numeric: false,disablePadding: false,label: "Numero", sorting: true},
  { id: "superficie", numeric: false,disablePadding: false,label: "Superficie", sorting: false},
  { id: "coordenadas", numeric: false,disablePadding: false,label: "Coordenadas", sorting: false},
  { id: "certificado", numeric: false,disablePadding: false,label: "Certificado", sorting: false},
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          !headCell.sorting ? <TableCell key={headCell.id}>{headCell.label}</TableCell> : (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className='hideSort'>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
}

function encodeQueryData(data) {
   const ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}

class Predios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      objects: [],

      html: {
        list: true,
        loading:false
      },
      filters: {
        estado_consolidado:''
      },
      pagination:{
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
      },
      sorting: {
        order_by:'created_at',
        order:'desc',
      },
      certificado_dialog:{
        open:false,
        certificado:null
      }
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.loadPredios = this.loadPredios.bind(this);
  }



  handleChangePage(event, page){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          page: page,
      }}), ()=> this.handleLoad());

  }
  handleChangeRowsPerPage(event){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          rows_per_page: event.target.value,
      }}), ()=> this.handleLoad());
  }

  handleSort(event, property){
    const isAsc = this.state.sorting.order_by === property && this.state.sorting.order === "asc";
    this.setState(prevState => ({
      sorting: {
          ...prevState.sorting,
          order: isAsc ? "desc" : "asc",
          order_by: property,
    }}),()=>this.handleLoad()
    );

  }


  handleLoad(){
    // console.log(this.state.filters)

    this.setState(prevState => ({
      html: {
        ...prevState.html,
        loading:true
      },
    }));

    var params = {
        page: this.state.pagination.page+1,
        order_by: this.state.sorting.order_by,
        order: this.state.sorting.order,
        rows_per_page: this.state.pagination.rows_per_page,
    };

    if(this.state.filters.rol && this.state.filters.rol!==''){
      params['rol'] = this.state.filters.rol;
    }
    if(this.state.filters.nombre && this.state.filters.nombre!=='none'){
      params['nombre'] = this.state.filters.nombre;
      console.log('alto')
    }
    // console.log(params)
    var query = encodeQueryData(params)

    authenticationService.fetchApi({
      url:'/obras/predio/?'+query,
      method: 'GET',
    })
    .then(result=>{
      let list = false;
      if(result.data.length > 0){
        list=true;
      }
      this.setState(prevState => ({
        pagination: {
            ...prevState.pagination,
            rows_num: result.rows_num
        },
        html: {
          ...prevState.html,
          list: list,
          show_view: true,
          show_credential_error:false,
          loading:false
        },
        objects: result.data
      }));
    })
    .catch(err=>{
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          show_view: false,
          show_credential_error:true,
          loading:false
        },
      }));
    });

  }

  loadPredios(){
    // console.log(this.state.filters)

    this.setState(prevState => ({
      html: {
        ...prevState.html,
        loading_predios:true
      },
    }));


    authenticationService.fetchApi({
      url:'/obras/predio/',
      method: 'POST',
    })
    .then(result=>{
      
    })
    .catch(err=>{
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          show_view: false,
          show_credential_error:true,
          loading_predios:false
        },
      }));
    });

  }

  createCertificado(predio_uuid){
    // console.log(this.state.filters)

    authenticationService.fetchApi({
      url:'/obras/certificado/',
      method: 'POST',

      body: JSON.stringify({predio_uuid:predio_uuid}),
    })
    .then(result=>{
      
      this.setState(prevState => ({
        certificado_dialog: {
          ...prevState.certificado_dialog,
          certificado: result,
          open:true,
        },
      }));
    })
    .catch(err=>{
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          show_view: false,
          show_credential_error:true,
          loading_predios:false
        },
      }));
    });

  }


  componentDidMount(){
    this.handleLoad();
  }

  handleCloseDialog(){
    this.setState(prevState => ({
      certificado_dialog: {
        ...prevState.certificado_dialog,
        open: false,
        certificado: null,
      },
    }));
  }

  handleFilterChange(event) {
    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value } = event.target;
    currentState[name] = value;
    this.setState({ filters: currentState },()=>{
      this.handleLoad();
    });

  }

  render() {
    return (
    <Layout title='Predios'>
      
      <Paper>
        <Box p={1} m={1}>

          <Box p={1}>
            <Typography variant='h5'>
              Predios
            </Typography>
          </Box>

          <Box p={1}>
          <TextField  name='rol'
                      id='rol'
                      label='Buscar por Rol'
                      placeholder='Buscar por Rol'
                      fullWidth
                      maxLength='100'
                      value={this.state.filters.rol}
                      onChange={this.handleFilterChange}
                      variant="standard"
                      />
          </Box>

          <Box p={1}>
          <TextField  name='rol'
                      id='rol'
                      label='Buscar por Calle'
                      placeholder='Buscar por Calle'
                      fullWidth
                      maxLength='100'
                      value={this.state.filters.nombre}
                      onChange={this.handleFilterChange}
                      variant="standard"
                      />
          </Box>
          <Box>
            {this.state.objects.length > 0 && this.state.html.list && !this.state.html.loading &&
            <Box p={1}>
              <TablePagination
                labelRowsPerPage='Resultados por página'
                component="div"
                count={this.state.pagination.rows_num}
                page={this.state.pagination.page}
                onPageChange={this.handleChangePage}
                rowsPerPage={this.state.pagination.rows_per_page}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
              <TableContainer>
                <Table size="small" >
                  <EnhancedTableHead
                    order={this.state.sorting.order}
                    orderBy={this.state.sorting.order_by}
                    onRequestSort={this.handleSort}
                  />
                  <TableBody>
                  {this.state.objects.map((object) => {
                    return(
                      <TableRow key={object.rol}>
                        <TableCell>
                          {(new Date(object.created_at)).toLocaleDateString('es-CL')}
                        </TableCell>
                        <TableCell>
                          {object.rol}
                        </TableCell>
                        <TableCell>
                          {object.nombre}
                        </TableCell>
                        <TableCell>
                          {object.numero}
                        </TableCell>
                        <TableCell>
                          {object.superficie}
                        </TableCell>
                        <TableCell>
                          {object.coordenada_x} - {object.coordenada_y}
                        </TableCell>
                        <TableCell>
                          <Button onClick={(event)=>this.createCertificado(object.predio_uuid)}>
                            Crear certificado
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            }
            { this.state.html.loading &&
              <CircularProgress />
            }
            {this.state.objects.length===0 && !this.state.html.loading &&
            <Box>
              <Box p={1}>
                <Alert severity='warning'>
                  No se encontraron Predios
                </Alert>
              </Box>
              <Box p={1} m={1} align='right'>
                <Button 
                        onClick = {this.loadPredios}
                        color='primary' 
                        variant='contained'>
                          Cargar Predios desde Google Sheet
                </Button>
              </Box>
            </Box>
            }
          </Box>
        </Box>
      </Paper>
      <Dialog open={this.state.certificado_dialog.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            {this.state.certificado_dialog.certificado &&
              <Box>
                <Typography variant="h6">
                  Descarga
                </Typography>
                <Box p={1}>
                  <Link target='blanc' 
                        to={{ pathname :this.state.certificado_dialog.certificado.pdf}}>
                    Descargar Certificado
                  </Link>
                </Box>
              </Box>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseDialog()} color="secondary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

    </Layout>
    );
  }
}

export default Predios;
